<template>
  <div
    class="flex-group"
    style="border-bottom: 1px solid grey; padding: 10px; font-size: 14px"
  >
    <div
      data-v-73a82902=""
      class="item"
      style="flex: 1; margin-right: 20px; text-align: left"
    >
      <p data-v-73a82902="" class="txt-bold">奖金金额：{{ SafeItem.money }}</p>
      <p data-v-73a82902="" class="payType">
        {{ SafeItem.gamename }}
      </p>
      <p data-v-73a82902="">
        领取时间：{{ SafeItem.state == 0 ? '暂未领取' : SafeItem.updated_at }}
      </p>
    </div>
    <div data-v-73a82902="" class="item">
      <p data-v-73a82902="" class="status">
        {{ SafeItem.state == 0 ? '待领取' : '已领取' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskFlowItemView',
  props: ['item'],
  computed: {
    SafeItem () {
      return this.item || {}
    }
  }
}
</script>

<style></style>
